module.exports = __webpack_public_path__ + "img/home--hero-bg@2x.093e8388.jpg";